import React from 'react';

import { Box, Grid as GridMui } from '@mui/material';

interface ContainerProps {
    children: React.ReactNode;
    className?: string;
}

export const Container = (props: ContainerProps) => {
    const { children, className } = props;

    return (
        <Box
            className={className}
            sx={{
                flex: '1 1 auto',
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
            }}
        >
            <Box
                sx={(theme) => ({
                    flex: '1 1 auto',
                    alignSelf: 'center',
                    width: '100%',
                    px: 2,
                    [theme.breakpoints.down('lg')]: {
                        maxWidth: 1200,
                    },
                    [theme.breakpoints.up('xl')]: {
                        maxWidth: 1440,
                    },
                    '@media print': {
                        p: 0,
                    },
                })}
            >
                <GridMui container>{children}</GridMui>
            </Box>
        </Box>
    );
};

export default Container;
